
function BlogNews(){
  return(
    <>
      Blog News
    </>
  )
}
export default BlogNews;